import { Box, Typography, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BOX_SHADOW, Grid_Gap } from "../../constants";

export const TopHeadSection = ({ headerText, RightContent }) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <Typography variant="h4" fontWeight={500} sx={{ textTransform: "capitalize" }}>
                {headerText}
            </Typography>
            {RightContent &&
                <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}>
                    {RightContent}
                </Box>
            }
        </Box>
    )
}

const NormalContainer = styled(Grid2)(({ theme, padding, boxShadow }) => ({
    // display: "grid",
    gap: Grid_Gap,
    boxShadow: boxShadow || BOX_SHADOW,
    padding: padding || "15px 14px",
    borderRadius: "15px",
    height: "100%",
    width: "100% ! important",
    backgroundColor: "#fff"
    //    alignItems:"start",
}));

const NormalContainerWithHeader = ({ children, headerText, customPadding, RightContent, boxShadow, isGrid = true }) => {
    return (
        <NormalContainer container padding={customPadding} boxShadow={boxShadow} >
            <TopHeadSection headerText={headerText} RightContent={RightContent} />
            {/* {
                isGrid && <Grid2 container spacing={Grid_Gap} sx={{height:"100%"}}>
                    {children}
                </Grid2>
            } */}


            <Box sx={{ height: "100%", width: "100%" }}>{children}</Box>

        </NormalContainer>
    );
};

export { NormalContainer, NormalContainerWithHeader };
